import React, { useRef, useState, useEffect } from "react"
import { useTheme } from '~/contexts/ThemeContext'
import { usePdp } from '~/contexts/PdpContext'

import IconClose from '~/components/icons/close'
import Sizes from '~/components/shared/sizes'
import Cta from '~/components/pdp/cta'

import { aria_btn, sticky_wr, sticky_b, sticky_f, solid_btn } from "~/styles/app.module.scss"
import * as styles from "~/styles/pdp/cta_bis.module.scss"

const StickyCta = () => {
  const { pdpVariant } = useTheme()
  const { showCta, showBis, showStickyCta } = usePdp()
  
  const [showWrap, setShowWrap] = useState(false)
  const [showPanel, setShowPanel] = useState(false)
  const [showSizes, setShowSizes] = useState(false)

  const panelRef = useRef(null)

  const animateOut = () => {
    const panel_el = panelRef.current
    panel_el.style.transform = ''
    setTimeout(()=>{
      setShowPanel(false)
      setShowSizes(false)
    }, 200)
    setTimeout(()=>{
      setShowWrap(false)
    }, 205)
    return
  }

  useEffect(() => {
    if (!showStickyCta) {
      if (showPanel && panelRef.current) {
        animateOut()
        return
      }
      return
    }
    setShowWrap(true)
    setShowPanel(true)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showStickyCta])

  useEffect(() => {
    if (!panelRef?.current) return
    if (!showStickyCta) return

    const panel_el = panelRef.current
    setTimeout(()=>{
      panel_el.style.transform = 'translate(0,0)'
    }, 50)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showPanel])

  useEffect(() => {
    if (pdpVariant) setShowSizes(false)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pdpVariant])

  
  return (
    <>
      {(!showBis && showWrap) ? (
        <div className={sticky_wr}>
          <div className={sticky_b} />
          <div className={sticky_f}>
            {showPanel && (
              <div className={styles.sticky_cta} ref={panelRef}>
                {(pdpVariant && showCta) ? (
                  <Cta npdp={true} sticky={true} />
                ) : showSizes ? (
                  <div className={styles.sticky_sizes}>
                    <div className={styles.sticky_closewr}>
                      <button 
                        type="button"
                        className={[aria_btn, styles.close].join(' ')}
                        aria-label="Close stores sidebar"
                        onClick={(e)=> {setShowSizes(false)}} 
                      >
                        <IconClose />
                      </button>
                    </div>
                    <Sizes />
                  </div>
                ) : (
                  <button 
                    type='button'
                    className={solid_btn}
                    onClick={(e)=> setShowSizes(true)}
                    style={{width: '100%'}}
                  >
                    Select Size to Add to Cart
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  )
}

export default StickyCta


